import { connect } from "react-redux";

var QuestionTypes = require("lib/academic/QuestionTypes");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var CommentBox = require("components/social/comments/CommentBox");
var BraveCheckbox = require("components/utility/BraveCheckbox");

require("writing/controls/feedback_controls.scss");

@connect(
	(state, props) => {
		var downProps = {}

		var answer = WritingSelectors.answer({ state, id: props.answerID });

		if (answer.quiz_id) {
			var subjectType = "QuizAnswer";
			var noun = "quiz";
			var quizID = answer.quiz_id;
			var quiz = WritingSelectors.quiz({ state, id: quizID });
			var allowRevision = (quiz || {}).allow_revision;

			var commentCount = 0;
			if (quiz) {
				var answerIDs = quiz.answers || quiz.answer_ids
				if (answerIDs) {
					_.each(answerIDs, (answerID) => {
						commentCount += WritingSelectors.comments({
							state, filters: { subject_type: subjectType, subject_id: answerID + "" }
						}).length;
					});
				}

				var revisedAt = quiz.revised_at;
			}

		} else {
			if (answer.question_type == QuestionTypes.REVIEW_QUESTION) {
				var subjectType = "JournalActivityReview";
				var noun = "review";
				var allowRevision = answer.allow_revision;
			} else {
				var subjectType = "JournalActivityAnswer";
				var noun = "answer"
				var allowRevision = answer.allow_revision;
			}

			var revisedAt = answer.revised_at;

			var commentCount = WritingSelectors.comments({
				state, filters: { subject_type: subjectType, subject_id: props.answerID + "" }
			}).length;
		}

		return {
			userID: answer.user_id,
			quizID, subjectType, noun, allowRevision, commentCount, revisedAt
		}
	}, 
	(dispatch, props) => ({
		setAllowRevisions: (id, isQuiz, allowRevision) => {
			if (isQuiz) {
				return dispatch(WritingActions.updateQuiz({
					id, update: { allow_revision: allowRevision }
				}))

			} else {
				return dispatch(WritingActions.updateAnswer({
					id, update: { allow_revision: allowRevision }
				}))
			}
		}
	})
)
class FeedbackControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	toggleAllowRevision() {
		if (this.props.quizID) {
			this.props.setAllowRevisions(this.props.quizID, true, !this.props.allowRevision);
		} else {
			this.props.setAllowRevisions(this.props.answerID, false, !this.props.allowRevision);
		}
	}
	render() {
		console.log("!!11!!", this.props.revisedAt, this.props.enabled.allowRevision)
		if (this.props.enabled.allowRevision) {
			var needsComments = this.props.commentCount < 1;

			if (needsComments) {
				var needsCommentsMessage = (
					<p className="needsCommentsMessage">
						Leave at least one comment to request a revision
					</p>
				)
			}

			if (!needsComments || this.props.allowRevision) {
				var revisionCheckbox = (
					<BraveCheckbox value={ this.props.allowRevision }
						onClick={ this.toggleAllowRevision }
						disabled={ needsComments && !this.props.allowRevision }
						text={ "Request a revision for this " + this.props.noun } />
				);
			}

			if (this.props.revisedAt) {
				var revisedAtText = (
					<p className="revisedAtText">
						<strong>Revised At</strong>: { $wr.formatDateTime(this.props.revisedAt, "show-past-years") }
					</p>
				)
			}
		}

		return (
			<div className="feedbackControls">
				<CommentBox subjectID={ this.props.answerID }
					subjectType={ this.props.subjectType }
					userID={ this.props.userID } initialCollapsed={ false } />

				{ needsCommentsMessage }
				{ revisionCheckbox }
				{ revisedAtText }
			</div>
		);
	}
};

FeedbackControls.WrappedComponent.propTypes = StrictPropTypes({
	answerID: PropTypes.number,
	quizID: PropTypes.number,
	allowRevision: PropTypes.bool,

	// "enabled" keys used in *this (feedback control)* component (others are ignored)
	//   allowRevision			-> Allows student to retake answer
	//
	enabled: PropTypes.object,

	// From @connect
	userID: PropTypes.number,
	noun: PropTypes.string,
	subjectType: PropTypes.string,
	commentCount: PropTypes.number,
	revisedAt: PropTypes.string,

	// Handlers from @connect
	setAllowRevisions: PropTypes.func
});

module.exports = FeedbackControls;



// WEBPACK FOOTER //
// ./modules/components/writing/controls/FeedbackControls.js